import React, { useState } from "react";
import { Airplane, CaretDown } from "@phosphor-icons/react";

export default function AircraftCard({ data, onFlyTo }) {
  const [open, setOpen] = useState(true);
  if (!data) return null;
  const aircraft = data.aircraft || [];

  return (
    <section data-testid="aircraft-card" className="border-b border-tac-border bg-tac-surface/40">
      <button
        type="button"
        data-testid="aircraft-toggle"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-2 px-4 py-2.5 text-left hover:bg-tac-surface/60 transition-colors"
      >
        <Airplane size={14} weight="fill" className={aircraft.length > 0 ? "text-[#4CC9F0]" : "text-tac-dim"} />
        <span className="text-[12px] uppercase tracking-[0.15em] font-bold text-tac-text">
          Fire Aviation
        </span>
        {aircraft.length > 0 && (
          <span className="text-[15px] font-mono-tac tabular text-[#4CC9F0]">· {aircraft.length}</span>
        )}
        <CaretDown
          size={12}
          weight="bold"
          className={`text-tac-dim transition-transform ml-auto ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open && aircraft.length === 0 && (
        <div className="px-4 pb-3 text-[14px] text-tac-faint" data-testid="aircraft-empty">
          No firefighting aircraft detected overhead right now
          {data.total_tracked > 0 ? ` · tracking ${data.total_tracked} aircraft in range` : ""}.
        </div>
      )}

      {open && aircraft.length > 0 && (
        <ul className="divide-y divide-tac-border/50" data-testid="aircraft-list">
          {aircraft.map((a) => (
            <li key={a.hex} className="px-4 py-2">
              <button
                type="button"
                onClick={() => onFlyTo?.(a.latitude, a.longitude)}
                className="w-full text-left group"
              >
                <div className="flex items-center gap-2">
                  <span className="font-mono-tac text-[14px] font-bold text-tac-text group-hover:text-tac-primary transition-colors">
                    {a.callsign || a.registration || a.hex}
                  </span>
                  <span className="px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider rounded-sm border border-[#4CC9F0]/40 text-[#4CC9F0] bg-[#4CC9F0]/10">
                    {a.kind}
                  </span>
                  <span className="text-[12px] font-mono-tac text-tac-faint ml-auto">
                    {a.on_ground ? "GND" : a.alt_ft != null ? `${Math.round(a.alt_ft / 100) * 100} ft` : "—"}
                  </span>
                </div>
                <div className="text-[13px] font-mono-tac text-tac-dim mt-0.5">
                  {a.desc || a.type || "Unknown type"}
                  {a.gs_kt != null ? ` · ${Math.round(a.gs_kt)} kt` : ""}
                </div>
                {a.operator && (
                  <div className="text-[11px] font-mono-tac text-tac-faint mt-0.5 uppercase">
                    {a.operator}
                  </div>
                )}
              </button>
            </li>
          ))}
        </ul>
      )}
      <div className="px-4 py-1.5 text-[11px] font-mono-tac text-tac-faint border-t border-tac-border/40">
        Live ADS-B (multi-source) · 15 s refresh · includes low aircraft within 10 mi of a fire
      </div>
    </section>
  );
}
